module.exports = __webpack_public_path__ + "img/error01.cfb26e78.png";